import { render, staticRenderFns } from "./OpenPositionsBlock.vue?vue&type=template&id=15c0bd7c"
import script from "./OpenPositionsBlock.vue?vue&type=script&lang=js"
export * from "./OpenPositionsBlock.vue?vue&type=script&lang=js"
import style0 from "./OpenPositionsBlock.vue?vue&type=style&index=0&id=15c0bd7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports